import { Form } from 'semantic-ui-react'
import styled from 'styled-components'

export const StyledFlagName = styled.div`
display: flex;
align-items: flex-start;
 .title {
  font-size: 16px !important;
  margin-left: 5px;
 }
 img {
  width: 28px !important;
 }
`
export const StyledAnswerWrapper = styled.div`
min-height: 100px;
margin-top: 30px;
 .disabled {
  opacity: 1 !important;
  label {
    opacity: 1 !important;
  }
 }
 .field {
  margin-top: 20px !important;
 }
`
export const StyledForm = styled(Form)`
 label {
  color: black !important;
 }
`
export const AnswerWrapper = styled.div`
  font-size: 15px !important;
  margin-bottom: 5px;
  border: 1px solid #e5e7eb;
  padding: 7px;
  border-radius: 5px;    
  color: #4183c4;
  cursor: grab !important;
  margin-left: 10px;
`